import type { IxcOrdersV1OrderKeys } from '@interxfi/types';
import { type EntityPathBuilder, getResolvedPath } from '../../util/routing/entity-paths';

export const ORDER_BASE_PATH = getResolvedPath('/order/equity');

export const getOrderPath: EntityPathBuilder<IxcOrdersV1OrderKeys> = (context) => {
  switch (context.kind) {
    case 'list':
      if (context?.keys?.accountId) {
        return getResolvedPath('/registration/account/$accountId/order/equity', context.keys);
      }

      return ORDER_BASE_PATH;
    case 'detail': {
      if (!context?.keys?.orderId) {
        return undefined;
      }

      if (context?.keys?.accountId) {
        return getResolvedPath('/registration/account/$accountId/order/equity/$orderId', context.keys);
      }

      return getResolvedPath(`${ORDER_BASE_PATH}/$orderId`, context.keys);
    }
  }
};

export function getOrderDetailPath(orderId: string | undefined, accountId?: string) {
  if (!orderId) {
    return undefined;
  }

  return getOrderPath({ kind: 'detail', keys: { orderId, accountId } });
}
